import { render, staticRenderFns } from "./ApiKeyRequirementFooter.vue?vue&type=template&id=30ae124e&scoped=true"
import script from "./ApiKeyRequirementFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApiKeyRequirementFooter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ApiKeyRequirementFooter.vue?vue&type=style&index=0&id=30ae124e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ae124e",
  null
  
)

export default component.exports